import { EUiStates } from "@constants/enum";
import { ArtistVerified } from "@enums/artistVerified";
import VerifiedIcon from "mdi-react/VerifiedIcon";
import { FormEvent, ReactElement } from "react";
import { Button, ButtonToolbar, Modal } from "reactstrap";
import styles from "./ModalVerifyArtist.module.scss";

interface IModalVerifyArtist {
  artistWalletAddress: string;
  artistVerified: ArtistVerified;
  modalStatus: boolean;
  handleModalStatus: () => void;
  modalType: EUiStates.DANGER;
  handleConfirm: (newVerified: ArtistVerified) => void;
}

const ModalVerifyArtist = ({
  artistWalletAddress,
  modalStatus,
  handleModalStatus,
  modalType,
  handleConfirm,
  artistVerified,
}: IModalVerifyArtist): ReactElement => {
  const handleOnSubmit = (form: FormEvent<HTMLFormElement>): void => {
    form.preventDefault();

    const data = new FormData(form.currentTarget);
    const newVerified = data.get("verified") as ArtistVerified;

    handleConfirm(newVerified);
  };

  return (
    <Modal isOpen={modalStatus} className={`modal-dialog--${modalType}`}>
      <form onSubmit={handleOnSubmit}>
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            aria-label="modal__close-btn"
            type="button"
            onClick={handleModalStatus}
          />
          <h4 className="text-modal modal__title">
            <span className={styles.verifyIcon}>
              <VerifiedIcon />
            </span>
            Artists | Verified Status
          </h4>
        </div>

        <div className="modal__body">
          Which type of verification would you like to give to{" "}
          {artistWalletAddress}?
          <select name="verified" className={styles.select}>
            {Object.entries(ArtistVerified).map((item) => (
              <option selected={artistVerified === item[1]} value={item[1]}>
                {item[1].replace("-", " ")}
              </option>
            ))}
          </select>
        </div>

        <ButtonToolbar className="modal__footer">
          <Button onClick={handleModalStatus}>Cancel</Button>
          <Button color={modalType} type="submit">
            Ok
          </Button>
        </ButtonToolbar>
      </form>
    </Modal>
  );
};

export default ModalVerifyArtist;
